import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salesDb } from "@/integrations/supabase/sales-client";
import { useAuth } from "@/context/auth";
import { toast } from "sonner";

export const useUnassignStudent = () => {
  const { user } = useAuth();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      assignmentId,
      fishsixCode,
      eventId,
    }: {
      assignmentId: string;
      fishsixCode: string;
      eventId: string;
    }) => {
      if (!user?.email || !user?.id) throw new Error("Not authenticated");
      const nowIso = new Date().toISOString();

      const { data: refund, error: rErr } = await salesDb()
        .from("student_cashbacks")
        .insert({
          fishsix_student_code: fishsixCode,
          hours: 1,
          action: "add",
          cashback_type: "event",
          status: "approved",
          created_by: user.email,
          approved_by: user.email,
          approved_at: nowIso,
        })
        .select("id")
        .single();
      if (rErr) throw rErr;

      const { error: uErr } = await salesDb()
        .from("event_assignments")
        .update({
          status: "unassigned",
          unassigned_at: nowIso,
          unassigned_by: user.id,
          refund_cashback_id: refund.id,
        })
        .eq("id", assignmentId);
      if (uErr) throw uErr;
    },
    onSuccess: (_d, vars) => {
      toast.success("ยกเลิกการมอบหมายและคืนครั้งแล้ว");
      qc.invalidateQueries({ queryKey: ["event-assignments", vars.eventId] });
      qc.invalidateQueries({ queryKey: ["event-balances"] });
      qc.invalidateQueries({ queryKey: ["student-event-history", vars.fishsixCode] });
    },
    onError: (e: any) => {
      toast.error(e?.message ?? "ยกเลิกไม่สำเร็จ");
    },
  });
};
